import {
    ButtonGroup, Flex,
    IconButton
} from '@chakra-ui/react'
import { useContext } from 'react'
import { Close, EditFilled } from '../icons'
import { EditableContext } from './EditableTinySelect'


export const CustomEditableControls = () => {
    const iconSize = 4
    const { isEditing, setIsEditing } = useContext(EditableContext)

    const handleClick = (e: React.MouseEvent, isEditing: boolean) => {
        setIsEditing(isEditing)
        e.stopPropagation()
    }

    return isEditing ? (
        <ButtonGroup justifyContent="center">
            <IconButton
                variant="ghost"
                colorScheme="white"
                aria-label="Zrušit"
                icon={<Close width={iconSize} height={iconSize} />}
                onClick={(e) => handleClick(e, false)} />
        </ButtonGroup>
    ) : (
        <Flex justifyContent="center">
            <IconButton
                variant="ghost"
                colorScheme="white"
                aria-label="Upravit limit"
                onClick={(e) => handleClick(e, true)}
            >
                <EditFilled color="gray.500" width={iconSize} height={iconSize} />
            </IconButton>
        </Flex>
    )
}
